import { ToothView } from '../../Enums/ToothView.enum';
import { Tooth, ToothJaw } from '../../../../graphql/graphql';

export default function getMouthViewPercentagePosition(
	tooth: Tooth,
	view: ToothView,
) {
	let positionPercent = 0.5;

	// Determine y position percentage based on jaw and view
	switch (view) {
		case ToothView.BUCCAL:
			positionPercent = tooth.jaw === ToothJaw.Upper ? 0.25 : 0.45;
			break;
		case ToothView.PALATAL:
			positionPercent = 0.35;
			break;
		case ToothView.LINGUAL:
			positionPercent = 0.25;
			break;
		default:
			positionPercent = 0.5;
	}

	return positionPercent;
}
